module.exports = __webpack_public_path__ + "img/canonical-line-short.69d603c1.svg";